import { render, staticRenderFns } from "./JobRoute.vue?vue&type=template&id=0bbbdca4"
import script from "./JobRoute.vue?vue&type=script&lang=js"
export * from "./JobRoute.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports